export function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

export function sortData(data, field, direction) {
  if (!field || !Array.isArray(data)) return data;
  const sortedData = [...data];
  sortedData.sort((a, b) => {
    let valA = a[field];
    let valB = b[field];

    if (
      field === 'created_at' ||
      field === 'published_at' ||
      field === 'priority_date'
    ) {
      const dateA = valA ? new Date(valA) : null;
      const dateB = valB ? new Date(valB) : null;
      if (dateA && dateB) {
        valA = dateA;
        valB = dateB;
      } else if (dateA) {
        return direction === 'asc' ? 1 : -1;
      } else if (dateB) {
        return direction === 'asc' ? -1 : 1;
      } else {
        return 0;
      }
    } else if (typeof valA === 'string' || typeof valB === 'string') {
      valA = (valA || '').toString().toLowerCase();
      valB = (valB || '').toString().toLowerCase();
    } else {
      valA = valA || 0;
      valB = valB || 0;
    }

    if (valA < valB) return direction === 'asc' ? -1 : 1;
    if (valA > valB) return direction === 'asc' ? 1 : -1;
    return 0;
  });
  return sortedData;
}

